import { isServer } from '@helpers/config';

export function getQueryParam(name: string): string | null {
    if (isServer()) {
        throw new Error('This function should be called in client side only.');
    }

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
